import { useQuery, UseQueryOptions } from "react-query";
import { Quest } from "../types";

import { getAllQuests } from "../api/Quests";

export const useAllQuestsQuery = (queryOptions?: UseQueryOptions<Quest[]>) => {
    return useQuery(['quests', 'all'], () => getAllQuests(), {
        ...queryOptions
    });
};